<p>{{ 'LOGGING_OUT' | translate }}</p>
